/**
 * Generates the full URL for an asset stored in the S3 bucket.
 * @param {string} assetPath - The relative path of the asset in the S3 bucket.
 * @returns {string} - The full URL of the asset.
 */
export function assets(assetPath: string): string {
    const S3_BUCKET_URL = process.env.NEXT_PUBLIC_S3_BUCKET_URL;

    if (!S3_BUCKET_URL) {
        throw new Error('S3_BUCKET_URL is not defined in the environment variables');
    }

    return `${S3_BUCKET_URL}/${assetPath}`;
}